import { render, staticRenderFns } from "./ConversaHistory.vue?vue&type=template&id=2f3460c8&scoped=true"
import script from "./ConversaHistory.vue?vue&type=script&lang=js"
export * from "./ConversaHistory.vue?vue&type=script&lang=js"
import style0 from "./ConversaHistory.vue?vue&type=style&index=0&id=2f3460c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3460c8",
  null
  
)

export default component.exports